import angular from 'angular';

angular.module('cloudX').directive('cxFiscalLoanList', function() {
  return {
    restrict: 'E',
    template: require('./fiscalLoanList.html'),
    bindToController: { field: '=', relId: '@', list: '=value' },
    controllerAs: 'vm',
    controller: [
      '$http',
      'appUrls',
      'flySvc',
      'ModalService',
      'dialogsSvc',
      'checkSecurity',
      function($http, appUrls, flySvc, ModalService, dialogsSvc, checkSecurity) {
        const vm = this;

        vm.$onInit = function() {
          if (!vm.list) vm.list = [];
          vm.documents = {};
          vm.documentLinkType = 9;

          if (vm.list && vm.list.length && checkSecurity('Documents:r')) {
            $http
              .post(
                `${appUrls.documents}/api/documents/GetLinks/${vm.documentLinkType}`,
                vm.list.map(x => x.id),
              )
              .then(function(response) {
                var result = response.data;
                angular.extend(vm.documents, result);
              })
              .catch(function(error) {
                flySvc.error(error);
                return '';
              });
          }

          vm.showInactiveLoans = false;
        };

        vm.isInactive = item => item.endDate && item.endDate <= new Date();
        vm.inactiveFilter = item => vm.showInactiveLoans || !vm.isInactive(item);

        vm.showDialog = function(item = null) {
          ModalService.showModal({
            template: require('../dialogs/fiscalLoanDialog.html'),
            controller: 'FiscalLoanDialog',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              relationId: vm.relId,
              data: item,
              documents: item ? vm.documents[item.id] : [],
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function([result = null, documents = null] = []) {
              if (result) {
                if (item && item.id) {
                  //Update
                  angular.extend(item, result);
                } else {
                  //Add
                  vm.list.push(result);
                }
              }
              const itemId = (item ? item.id : null) || (result ? result.id : null);
              if (documents && itemId) {
                vm.documents[itemId] = [...documents];
              }
            });
          });
        };

        vm.add = () => vm.showDialog(null);
        vm.edit = item => vm.showDialog(item);

        vm.remove = function(item) {
          if (item.deleting) return;
          return dialogsSvc.showYesNo('comfirmDeleteTitle', 'comfirmDeleteItem').then(
            function() {
              item.deleting = true;
              return $http.delete(`${appUrls.api}/api/Fiscal/Loan/${item.id}`).then(
                () => {
                  item.deleting = false;
                  const idx = vm.list.indexOf(item);
                  if (idx >= 0) {
                    vm.list.splice(idx, 1);
                  }
                  if (vm.documents[item.id] && vm.documents[item.id].length > 0) {
                    //Delete document links
                    return $http
                      .delete(
                        `${appUrls.documents}/api/documents/Links/${item.id}/${vm.documentLinkType}`,
                      )
                      .then(() => {
                        delete vm.documents[item.id];
                        flySvc.success('msgItemRemoved');
                      });
                  }
                  flySvc.success('msgItemRemoved');
                },
                error => {
                  item.deleting = false;
                  flySvc.error(error);
                },
              );
            },
            function() {
              return false;
            },
          );
        };
        vm.uploadDocuments = function(files, item) {
          if (!item || !item.id) return;
          if (!files || files.length < 1) return;
          var formData = new FormData();
          formData.append('relationId', vm.relId);
          formData.append('documentLinkType', vm.documentLinkType);
          formData.append('linkId', item.id);

          files.forEach(function(file) {
            formData.append('data', file.data);
          });

          $http({
            method: 'POST',
            url: appUrls.documents + '/api/documents?documentType=-1',
            headers: {
              'Content-Type': undefined,
            },
            data: formData,
          })
            .then(function(response) {
              var result = response.data;
              if (result && result.length > 0) {
                if (!vm.documents[item.id]) vm.documents[item.id] = [];

                result.forEach(function(file) {
                  vm.documents[item.id].push(file);
                });
                flySvc.success();
              }
            })
            .catch(function(error) {
              flySvc.error(error);
              return '';
            });
        };
      },
    ],
  };
});
